import(/* webpackMode: "eager" */ "/opt/build/repo/frontend/app/share/[share_token]/page.tsx");
